import { all } from 'redux-saga/effects';
import getCompaniesSaga from './watchers/getCompanies';
import getCompaniesPublicSaga from './watchers/getCompaniesPublic';

function* competencesSaga() {
  yield all([getCompaniesSaga(), getCompaniesPublicSaga()]);
}

export default competencesSaga;
